// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import App from './App'
import VueRouter from 'vue-router'
import Moment from 'vue-moment'
import routes from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import VModal from 'vue-js-modal'
import Paginate from 'vuejs-paginate'
import VueClipboard from 'vue-clipboard2'
import Helpers from './assets/js/core/Helpers'
import FileFlip from './assets/js/core/FileFlip'
import store from './store/store'

const router = new VueRouter({routes}.routes)
Vue.router = router

let appOptions = {
    el: '#app',
    name: 'app',
    store,
    router,
    template: '<App/>',
    components: { App },
    mounted () {
    }
}

/**
 * Clear old token if user auth data is passed.
 */
if (window.location.href.includes('user=')) {
    localStorage.removeItem('default_auth_token')
}

Vue.config.productionTip = false

Vue.component('paginate', Paginate)

Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.use(VueClipboard)
Vue.use(VueAuth, {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    tokenName: 'auth_token',
    refreshData: {url: 'auth/refresh', method: 'GET', enabled: true, interval: 15},
    rolesVar: 'status'
})
Vue.use(Moment)
Vue.use(VModal)

// Set our base url
let url = window.location.href
let baseURL = 'https://qainterface.primoprint.com'
console.log('url', url)
// Production
if (!url.includes('localhost') && !url.includes('qadesigner')) {
    baseURL = 'https://interface.primoprint.com'

    // Sentry Error Tracking
    Raven
        .config('https://90d2bab5ba4f4a5aac48ba3b0bcfacd9@sentry.io/303632', {
            'release': process.env.SENTRY_RELEASE
        })
        .addPlugin(RavenVue, Vue)
        .install()
}

Vue.axios.defaults.baseURL = baseURL + '/v1'
Vue.axios.defaults.headers.common['Accept'] = 'application/json'
// Vue.axios.defaults.headers["Access-Control-Allow-Origin"] = "*"

window.Helpers = Helpers
window.FileFlip = FileFlip

/* eslint-disable no-new */
new Vue(appOptions)



// WEBPACK FOOTER //
// ./src/main.js